import { useMutation, useQueryClient } from '@tanstack/vue-query'
import {
  addDiscount,
  addTier,
  deleteDiscount,
  deleteTier,
  setPaymentSystem,
  updateDiscount,
  updateTier,
} from '@/modules/Payment/api/service'
import { eventKey } from '@/enitites/event/api/keys'

const updateEventCache = (queryClient: ReturnType<typeof useQueryClient>, data: { id: number }) => {
  queryClient.setQueryData(eventKey.edit(data.id), data, {
    updatedAt: Date.now(),
  })
}

export const useSetPaymentSystem = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: setPaymentSystem,
    onSuccess: (data) => updateEventCache(queryClient, data),
  })
}

export const useAddTier = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addTier,
    onSuccess: (data) => updateEventCache(queryClient, data),
  })
}

export const useUpdateTier = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateTier,
    onSuccess: (data) => updateEventCache(queryClient, data),
  })
}

export const useDeleteTier = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteTier,
    onSuccess: (data) => {
      if (data.message !== 'ok') return
      queryClient.invalidateQueries({ queryKey: eventKey.edit(data.eventId) })
    },
  })
}

export const useAddDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addDiscount,
    onSuccess: (data) => updateEventCache(queryClient, data),
  })
}

export const useUpdateDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateDiscount,
    onSuccess: (data) => updateEventCache(queryClient, data),
  })
}

export const useDeleteDiscount = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteDiscount,
    onSuccess: (data) => {
      if (data.message !== 'ok') return
      queryClient.invalidateQueries({ queryKey: eventKey.edit(data.eventId) })
    },
  })
}
